import { render, staticRenderFns } from "./SourceAddDialog.vue?vue&type=template&id=7980505f&scoped=true"
import script from "./SourceAddDialog.vue?vue&type=script&lang=js"
export * from "./SourceAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7980505f",
  null
  
)

export default component.exports